import { wScroll, shadow } from './scroll';
import { logger } from '@/plugins/logger';
const LOGGER_TAG = 'directives';

export default function (app) {
    logger.info(LOGGER_TAG, 'installing directives');
    app.directive('wscroll', wScroll);
    app.directive('shadow-sm', shadow);
}